// Exports
// -------

// Media queries
//
// TODO: Share these media queries between CSS and JS instead of copying:
//       /app/styles/principles/variables/_media-queries.sass
export default {
    // width
    'width-xxs': {
      query: '(min-width: 240px)'
    },
    'width-xs': {
      query: '(min-width: 300px)'
    },
    'width-s': {
      query: '(min-width: 440px)'
    },
    'width-m': {
      query: '(min-width: 600px)'
    },
    'width-l': {
      query: '(min-width: 750px)'
    },
    'width-xl': {
      query: '(min-width: 900px)'
    },
    'width-xxl': {
      query: '(min-width: 1044px)'
    },
    'width-xxxl': {
      query: '(min-width: 1168px)'
    },

    // height
    'height-s': {
      query: '(min-height: 320px)'
    },
    'height-m': {
      query: '(min-height: 460px)'
    },
    'height-l': {
      query: '(min-height: 600px)'
    },
    'height-xl': {
      query: '(min-height: 750px)'
    },
    'height-xxl': {
      query: '(min-height: 900px)'
    },

    // resolution
    'min-dppx-1-5': {
      query: `
        (-webkit-min-device-pixel-ratio: 1.5),
        (min-resolution: 144dpi),
        (min-resolution: 1.5dppx)`
    }
  };



/** WEBPACK FOOTER **
 ** ./~/vt-frontend-engine/app/scripts/principles/responsive/media-queries.js
 **/